import { Action } from "redux"

import * as actions from "./actions"
import { IUserInfo } from "./index"

export const initialState: IUserInfo = {
    fullName: "",
    hasLogout: false,
    hasReports: false,
    hasSettings: false,
    hasTimesheet: false,
    helpUrl: "",
    homePageUrl: "",
    iconUrl: "",
    privacyPolicyUrl: "",
    canCreateWorkspace: false,
    showDashboard: false,
    defaultNavigationTab: 0,
}

const ACTION_HANDLERS: {
    [action: string]: (state: IUserInfo, props: Action) => IUserInfo
} = {
    [actions.INITIALIZE]: (state, props: actions.Initialize): IUserInfo => ({
        ...state,
        ...props,
    }),

    [actions.RECEIVE_HOME_PAGE_URL]: (
        state,
        { homePageUrl }: actions.ReceiveHomePageUrl,
    ): IUserInfo => ({ ...state, homePageUrl }),

    [actions.UPDATE_DEFAULT_NAVIGATION_TAB]: (
        state,
        { defaultNavigationTab }: actions.UpdateDefaultNavigationTab,
    ): IUserInfo => ({ ...state, defaultNavigationTab }),
}

export default function reducer(
    state: IUserInfo = initialState,
    action: Action,
): IUserInfo {
    const handler: (state: IUserInfo, action: Action) => IUserInfo =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
